"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getInitialFilters;
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function getInitialFilters(options) {
  return _lodash["default"].flatten(_lodash["default"].compact(_lodash["default"].map(options, function (o) {
    if (_lodash["default"].has(o, 'children') && !_lodash["default"].isEmpty(o.children)) {
      return _lodash["default"].compact(_lodash["default"].map(o.children, function (opt) {
        return opt.initial ? opt.value : null;
      }));
    }
    return o.initial ? o.value : null;
  })));
}